import * as api from "./middleware/api.middleware";

export function getForgetPasswordToken(x: string) {
  const getResponse = api.post<any>(`forgot_password`, {
    email: x,
    is_active: true,
  });
  return getResponse;
}
